import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import { __decorate } from "tslib";
import { Component, createRef } from 'intact-react';
import { sizes } from '../../styles/utils';
import template from './index.vdt';
import { bind, selectValue } from '../utils';
import { useAutoWidth } from './useAutoWidth';
import { useFrozen } from './useFrozen';
import { useAutoRows } from './useAutoRows';
import { useShowPassword } from './useShowPassword';
import { useFocus } from './useFocus';
import { useConfigContext } from '../config';
export * from './search';
var typeDefs = {
  type: String,
  value: [String, Number],
  defaultValue: [String, Number],
  placeholder: String,
  readonly: Boolean,
  clearable: Boolean,
  disabled: Boolean,
  size: sizes,
  rows: [String, Number, 'auto', Object],
  autoWidth: Boolean,
  fluid: Boolean,
  width: [Number, String],
  stackClearIcon: Boolean,
  frozenOnInput: Boolean,
  inline: Boolean,
  waveDisabled: Boolean,
  resize: ['none', 'vertical', 'horizontal', 'both'],
  showPassword: Boolean,
  flat: Boolean,
  showCount: Boolean
};
var defaults = function defaults() {
  return {
    type: 'text',
    size: 'default',
    rows: 2,
    resize: 'vertical'
  };
};
var events = {
  clear: true,
  focus: true,
  blur: true,
  input: true
};
export var Input = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Input, _Component);
  function Input() {
    var _context;
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, _concatInstanceProperty(_context = [this]).call(_context, args)) || this;
    _this.inputRef = createRef();
    _this.autoWidth = useAutoWidth();
    _this.frozen = useFrozen();
    _this.autoRows = useAutoRows(_this.inputRef);
    _this.showPassword = useShowPassword();
    _this.focusHook = useFocus();
    _this.config = useConfigContext();
    return _this;
  }
  var _proto = Input.prototype;
  _proto.focus = function focus() {
    this.inputRef.value.focus();
  };
  _proto.blur = function blur() {
    this.inputRef.value.blur();
  };
  _proto.select = function select() {
    selectValue(this.inputRef.value);
  };
  _proto.clear = function clear(e) {
    this.set('value', '');
    this.focus();
    this.trigger('clear', e);
  };
  return Input;
}(Component);
Input.template = template;
Input.typeDefs = typeDefs;
Input.defaults = defaults;
Input.events = events;
__decorate([bind], Input.prototype, "clear", null);